export const enterFullscreen = async (navigate, path) => {
  const elem = document.documentElement;

  const requestFullscreen = () => {
    if (elem.requestFullscreen) return elem.requestFullscreen();
    if (elem.webkitRequestFullscreen) return elem.webkitRequestFullscreen();
    if (elem.mozRequestFullScreen) return elem.mozRequestFullScreen();
    if (elem.msRequestFullscreen) return elem.msRequestFullscreen();
    return Promise.reject("Fullscreen API not supported");
  };

  try {
    // Attempt fullscreen
    await requestFullscreen();
  } catch (err) {
    console.warn("Fullscreen request failed:", err);
  } finally {
    // If a path and navigate function are provided, continue to navigation
    if (navigate && path) {
      navigate(path);
    }
  }
};